import { render, staticRenderFns } from "./SubmenuPage.vue?vue&type=template&id=429acc59&class=menuIndex"
import script from "./SubmenuPage.vue?vue&type=script&lang=ts"
export * from "./SubmenuPage.vue?vue&type=script&lang=ts"
import style0 from "./SubmenuPage.vue?vue&type=style&index=0&id=429acc59&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports